module.exports = __webpack_public_path__ + "img/Color 074.44f243be.jpg";